(() => {
  const button = document.querySelector('[data-restored-map]');
  if (!button) return;
  button.addEventListener('click', () => {
    const scope = button.closest('.dm-restored-map');
    const host = scope.querySelector('[data-map-host]');
    const status = scope.querySelector('[data-map-status]');
    button.disabled = true;
    host.hidden = false;
    status.textContent = status.dataset.loading;
    const script = document.createElement('script');
    script.src = 'https://stockist.co/embed/v1/widget.min.js';
    script.async = true;
    script.onload = () => { status.textContent = ''; button.hidden = true; };
    script.onerror = () => { status.textContent = status.dataset.error; host.hidden = true; button.disabled = false; script.remove(); };
    document.head.appendChild(script);
  });
})();
